module.exports = __webpack_public_path__ + "b906ffec4ebc7639d102635373dac446.svg";